import './App.css';
import Logo from './images/Logo.png';

function App() {
  return (
    <div className="container">
      <img className="image" src={Logo} alt="Logo"  />
      <h1>Lassana Crafts</h1>
      <h2>Coming Soon</h2>
    </div>
  );
}

export default App;
